goog.provide('el8.appchart.dialog.eligibilities');

// causes weird deps ordering problem with el8.data.practiceSettings not existing in
//  addEditProblem.js -- commenting out
// goog.require('el8.appchart.refpanel.maint');
goog.require('el8.appshared.dialog.patientFields');
goog.require('el8.appshared.eligibility');
goog.require('el8.appshared.form.eligibilityFields');
goog.require('el8.ptdata.eligibilities');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.eligibilities');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');


/**
 * This is a strange dialog because it has two very distinct "modes" -
 * one is a traditional form (add patient info to then send & check med eligibility)
 * whereas the other is just made to mimic a form to keep things simple (display
 * patient's valid eligibilities).  As a result, we have to instantiate a new Form object
 * every time the dialog is shown, and we have to do custom calls of dialog _init() 
 * and show() methods
 */

el8.appchart.dialog.eligibilities = (function() {

    var that = new el8.uiwidget.FormDialog({
        title: 'Medication Coverage Eligibility & Medication Fills',
        autoHeight: true,
        width: 600
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        el8.ptdata.eligibilities.softLoad(null, false);
    };

    var super_show = that.show;
    that.show = function(submitRequest) {

        if (!that._isInit) { that._init(); }

        var tmplArgs = {};

        // If there are successful eligibility records to display
        if (el8.ptdata.eligibilities.hasValid()) {
            tmplArgs['eligibilities'] = el8.ptdata.eligibilities.all().map(
                function(a) {
                    return {
                        createDate: el8.service.tz.soyStr(a.getCreateDate()),
                        pbmName: a.getPbmName(),
                        eligPatient: a.getEligPatient(),
                        hasUpdates: a.isHasUpdates(),
                        planName: a.getPlanName(),
                        planStatus: a.getPlanStatus(),
                        planPcn: a.getPlanPcn(),
                        coverages: a.getCoverages().map(function(b) {
                            return {
                                status: b.getStatus(),
                                serviceType: b.getServiceType(),
                                planName: b.getPlanName()
                            };
                        }),
                        error: a.getError()
                    };
                }
            );
            that.setContent(el8.template.appchart.dialog.eligibilities.content(tmplArgs));

            // We create a form so that we can show buttons, which makes it easier to 
            // switch between this display and the form display (rather than have to reset
            // the buttons every time)
            var form = new el8.uiwidget.Form({
                fields: [],
                buttons: [
                    ['close', 'Close', function() { that.hide(); }, true]
                ]
            });
            that.setForm(form);

            super_show.call(that);

        // Else, display form for user to check for eligibility
        } else {
            tmplArgs['eligibilities'] = [];
            tmplArgs['failureReason'] = el8.ptdata.eligibilities.all().length ? el8.ptdata.eligibilities.getLastError() : '';
            if (!el8.data.phoneTypes.length) {
                $.el8_ajax({
                    url: el8.service.urls.get('patientFormInfo'),
                    type: 'GET',
                    async: false,
                    success: function(data) {
                        el8.data.phoneTypes = $.parseJSON(data['phone_types']);
                        el8.data.races = $.parseJSON(data['races']);
                        el8.data.ethnicities = $.parseJSON(data['ethnicities']);
                    }
                });
            }
            tmplArgs['phoneTypes'] = el8.data.phoneTypes;
            that.setContent(el8.template.appchart.dialog.eligibilities.content(tmplArgs));

            initForm();

            if (!el8.appshared.eligibility.isRequestInProgress() && submitRequest) {
                submitEligibilityRequest(that.getForm());
            }
        }

        function submitEligibilityRequest(_form) {
            // Doesn't check for form being valid; relies on external caller to do its own if desired
            _form.disable();
            el8.appshared.eligibility.submitRequest(el8.ptdata.currPatient, {
                successCb: function() { 
                    that.hideLoading();
                    that.show();
                },
                failureCb: function() { 
                    el8.uiwidget.confirm(
                        'Medication coverage eligibility could not be retrieved. Update patient information and try again?',
                        function() { 
                            that.hideLoading();
                            _form.enable();
                            _form.initFocus();
                        },
                        function() { 
                            that.hideLoading();
                            that.hide(); 
                        }
                    );
                },
                failureNoRetryCb: function(msg) { 
                    el8.uiwidget.alert(
                        'Medication coverage eligibility could not be retrieved.  ' + msg, null,
                        function() { 
                            that.hideLoading();
                            that.hide(); 
                        }
                    );
                },
                pendingCb: function() {
                    that.displayLoading();
                }
            });
        }

        function initForm() {
            var form = new el8.uiwidget.Form({
                fields: el8.appshared.form.eligibilityFields,
                validationOpts: el8.appshared.dialog.patientFields.patientValidationOpts
            });
            form.addButton('check-eligibility', 'Check Eligibility & Retrieve Meds',
                function(_form) {
                    if (!_form.isValid() || !_form.getVal('lastName')) { return; }
                    _form.disable();

                    el8.appservice.notifier.notify('Saving patient info...');

                    $.el8_ajax({
                        url: el8.service.urls.get('patientDemographics', [el8.ptdata.currPatient.getId()]),
                        type: 'POST',
                        async: false,
                        data: JSON.stringify(_form.getMapped(false, true)),
                        success: function(data) {
                            var patient = el8.ptdata.currPatient;
                            patient.populate(data);
                            el8.appservice.notifier.notify('Patient info saved.');
                            el8.appchart.refpanel.demog.triggerRender();
                            el8.appchart.refpanel.maint.render(true);
                        }
                    });

                    submitEligibilityRequest(_form);

                }, true);
            form.addCancelButton(function() {
                that.hide();
            });
            that.setForm(form);
            super_show.call(that);

            form.populate(el8.ptdata.currPatient.asFormMap());
            form.initFocus();
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.clearForm();
        el8.appservice.notifier.clear();
    };

    return that;

})();

